import { utils as commonUtils } from 'mage-common'
import path from 'path'

import { getConfig } from '../config'
import * as u from '../utils'

const withContext = (fn) => {
  const enabled = getConfig('insights.googleAnalytics.enabled', false)
  const context = getConfig('context')

  if (!enabled) return false

  if (!context.ga) {
    context.ga = function () {
      (context.ga.q = context.ga.q || []).push(arguments)
    }
    context.ga.l = +new Date()
  }

  fn(context.ga)
}

const create = () => withContext((ga) => {
  const trackingId = getConfig('insights.googleAnalytics.trackingId')

  ga('create', trackingId, 'auto')
})

const pageview = (pathname, search) => withContext((ga) => {
  const clientId = getConfig('clientId', '')

  ga('send', 'pageview', path.join(clientId, pathname, search))
})

const setUser = userData => withContext(ga => {
  const { user_id: userId } = userData
  ga('set', 'userId', userId)
  data({
    user_id: userId
  })
})

const setRealm = realm => withContext(ga => {
  data({
    user_realm: realm
  })
})

const data = (custom) => withContext((ga) => {
  const dimensions = getConfig('insights.googleAnalytics.dimensions', {})
  const metrics = getConfig('insights.googleAnalytics.metrics', {})

  const set = u.translateKeys(custom, dimensions, metrics)

  if (Object.keys(set).length === 0) return

  ga('set', set)
})

const event = ({ category, action, label = null, value = null, customData = {} }) => withContext((ga) => {
  data(customData)
  const clientId = getConfig('clientId', '')

  if (!category || !action) {
    console.warn('insights/event requires category & action')
    return
  }

  ga('send', 'event', commonUtils.cleanObject({
    eventCategory: `${clientId}/${category}`,
    eventAction: action,
    eventLabel: label,
    eventValue: value
  }))
})

const logException = ({ type = 'n/a' }) => withContext((ga) => {
  const clientId = getConfig('clientId', '')

  ga('send', 'exception', {
    exDescription: `${clientId}/${type}`
  })
})

export {
  create,
  pageview,
  setUser,
  setRealm,
  data,
  event,
  logException
}
